export default "__VITE_ASSET__CTz_6Pbg__"